import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { McInput } from "@maersk-global/mds-react-wrapper/mc-input";
import apiClient from "../api/apiClient";
import { McButton, McIcon } from "@maersk-global/mds-react-wrapper";
import { McSelect } from "@maersk-global/mds-react-wrapper/mc-select";
import { McOption } from "@maersk-global/mds-react-wrapper/mc-option";
import { useDispatch, useSelector } from "react-redux";
import { resetProfile } from "../redux/profileSlice";
import { apiUrl } from "../authconfig";
const ProfilePage = () => {

const [mydata,setMyData] = React.useState({});
const navigate = useNavigate();
const dispatch = useDispatch();
const currentUser = React.useMemo(() => {
  try {
    return JSON.parse(sessionStorage.getItem("user")) || {};
  } catch {
    return {};
  }
}, []);
const userPrincipalName = (currentUser?.mail || "").toLowerCase();

const myProfileData = useSelector((state) => state.profile.data);
useEffect(() => {

    setMyData(myProfileData || {});

}, [myProfileData]);

// const fetchMyData = async () => {


// const url = `${apiUrl}/api/point-data/getByEmail/${(userPrincipalName || '').toLowerCase()}`;
// apiClient.get (url).
// then((response) => {
//     setMyData(response.data);
//     console.log('response',response.data);
// }).catch((error) => {
//     console.log('error',error);
// });

// }

const handleSaveFunction = async () => {
  try {
    console.log('mydata',mydata);
    const payload = {
      function: mydata?.function ?? "",
      ...mydata,
    };
    const res = await apiClient.put(
      `${apiUrl}/api/point-data/${mydata?.employeeUniqueId}/function`,
      payload
    );
    console.log("save response", res?.data);
    alert("Profile updated successfully");
    dispatch(resetProfile())
  } catch (error) {
    console.log("save error", error);
  }
};


  return (
    <div
      style={{
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div className="Project" style={{ color: "rgb(0, 36, 61)" }}>
          My Profile
        </div>
        <button
          onClick={() => navigate('/opportunities')}
          aria-label="Close and go to Project Queue"
          style={{
            background: 'transparent',
            border: 'none',
            fontSize: '28px',
            cursor: 'pointer',
            color: 'rgb(0, 36, 61)'
          }}
        >
          ×
        </button>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: "50px",
        }}
      >

        {/* Row 1 */}
        <div style={{ display: "flex", gap: "50px" }}>
          <div style={{ display: "flex", width: "50%" }}>
            <div className="DetailsLabel">Employee Unique Id</div>
            <div className="DetailsLabel">
              <McInput
                className="inputReadonly"
                hiddenlabel="true"
                fit="small"
                readonly={true}
                value={mydata?.employeeUniqueId || ""}
              ></McInput>
            </div>
          </div>
          <div style={{ display: "flex", width: "50%" }}>
            <div className="DetailsLabel">Name Of Employee</div>
            <div className="DetailsLabel">
              <McInput
                className="inputReadonly"
                hiddenlabel="true"
                fit="small"
                readonly={true}
                value={mydata?.nameOfEmployee || ""}
              ></McInput>
            </div>
          </div>
        </div>

        {/* Row 2 */}
        <div style={{ display: "flex", gap: "50px" }}>
          <div style={{ display: "flex", width: "50%" }}>
            <div className="DetailsLabel">Official Email Address</div>
            <div className="DetailsLabel">
              <McInput
                className="inputReadonly"
                hiddenlabel="true"
                fit="small"
                readonly={true}
                value={mydata?.officeEmailAddress || ""}
              ></McInput>
            </div>
          </div>
          <div style={{ display: "flex", width: "50%" }}>
            <div className="DetailsLabel">Country</div>
            <div className="DetailsLabel">
              <McInput
                className="inputReadonly"
                hiddenlabel="true"
                fit="small"
                readonly={true}
                value={mydata?.country || ""}
              ></McInput>
            </div>
          </div>
        </div>

        {/* Row 3 */}
        <div style={{ display: "flex", gap: "50px" }}>
          <div style={{ display: "flex", width: "50%" }}>
            <div className="DetailsLabel">Area</div>
            <div className="DetailsLabel">
              <McInput
                className="inputReadonly"
                hiddenlabel="true"
                fit="small"
                readonly={true}
                value={mydata?.area || ""}
              ></McInput>
            </div>
          </div>
          <div style={{ display: "flex", width: "50%" }}>
            <div className="DetailsLabel">Region</div>
            <div className="DetailsLabel">
              <McInput
                className="inputReadonly"
                hiddenlabel="true"
                fit="small"
                readonly={true}
                value={mydata?.region || ""}
              ></McInput>
            </div>
          </div>
        </div>

        {/* Row 4 */}
        <div style={{ display: "flex", gap: "50px" }}>
          <div style={{ display: "flex", width: "50%" }}>
            <div className="DetailsLabel">Manager Unique Id</div>
            <div className="DetailsLabel">
              <McInput
                className="inputReadonly"
                hiddenlabel="true"
                fit="small"
                readonly={true}
                value={mydata?.managerUniqueId || ""}
              ></McInput>
            </div>
          </div>
          <div style={{ display: "flex", width: "50%" }}>
            <div className="DetailsLabel">Manager Name</div>
            <div className="DetailsLabel">
              <McInput
                className="inputReadonly"
                hiddenlabel="true"
                fit="small"
                readonly={true}
                value={mydata?.managerName || ""}
              ></McInput>
            </div>
          </div>
        </div>

        {/* Row 5 */}
        <div style={{ display: "flex", gap: "50px" }}>
          <div style={{ display: "flex", width: "50%", alignItems: "center" }}>
            <div className="DetailsLabel">Function</div>
            <div className="DetailsLabel" style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '8px' }}>


              <McSelect
             
                                hiddenlabel="true"
                                fit="medium"
                                name="cancelReason"
                                 value={mydata?.function ?? ""}
                                optionselected={(e) => setMyData(prev => ({ ...prev, function: e.target.value }))}
                                placeholder="select function"
                                isClearable
                                
                              >
                                 <McOption value="CX (Area+GSC)">
                                  CX (Area+GSC)
                                </McOption>
                                 <McOption value="TbM OPS (LCL, Landside, others)
">
                                  TbM OPS (LCL, Landside, others)

                                </McOption>
                                <McOption value="Air Team">
                                  Air Team
                                </McOption>
                                <McOption value="CPM team">
                                  CPM team
                                </McOption>
                                <McOption value="Alianca team">
                                  Alianca team
                                </McOption>
                                <McOption value="Customs team">
                                  Customs team
                                </McOption>
                              </McSelect>
               
              
              
            </div>
          </div>
          <div style={{ display: "flex", width: "50%" }}>
            
          </div>
        </div>

        <div style={{ width:"100%", display:'flex', justifyContent:'center' }} >
          <McButton click={handleSaveFunction}>
            Save Changes
          </McButton>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
